import { Box, Button, Checkbox, Collapse, IconButton, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { StyledMainTableCell, StyledMainTableRow } from "../../../components/TableComponent";
import { useEffect, useState } from "react";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import dayjs from "dayjs";
import styles from "./list.module.css";

const TableCustomRow = ({ item, isItemSelected, selectRowEvent, makeReceivedNew }) => {
    const [open, setOpen] = useState(false);
    const [remainingItemIds, setRemainingItemIds] = useState([]);

    useEffect(() => {
        let remainingItemIdsTemp = item?.products?.map((i) => {
            if (i?.is_wh_received === 0) return i?.id;
            return null;
        });

        remainingItemIdsTemp = remainingItemIdsTemp?.filter((i) => i !== null);

        setRemainingItemIds(remainingItemIdsTemp);
    }, [item]);

    const allReceived = remainingItemIds?.length === 0;

    return (
        <>
            <StyledMainTableRow
                className={styles.DataRow}
                sx={{ "& > *": { borderBottom: "unset" }, cursor: "pointer" }}
                onClick={() => selectRowEvent(item?.id)}
                aria-checked={isItemSelected}
                selected={isItemSelected}
            >
                <TableCell padding="checkbox" className={styles.CheckboxCell}>
                    <Checkbox color="primary" checked={isItemSelected} />
                </TableCell>

                <TableCell data-label="Booking ID" className={styles.BookingIdCell}>
                    <IconButton
                        aria-label={open ? "Collapse items" : "Expand items"}
                        size="small"
                        onClick={(e) => {
                            e.stopPropagation();
                            setOpen(!open);
                        }}
                        sx={{ mr: 0.5 }}
                    >
                        {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                    </IconButton>
                    <span className={styles.BookingIdText}>{item?.booking_id}</span>
                </TableCell>

                <TableCell data-label="Customer" component="th" scope="row">
                    {item?.customer_name}
                </TableCell>

                <TableCell data-label="Address" component="th" scope="row">
                    {item?.pickup_details?.address}
                </TableCell>

                <TableCell data-label="Pickup Date" component="th" scope="row">
                    {dayjs(item?.pickup_date).format("DD/MM/YYYY")}
                </TableCell>

                <TableCell component="th" scope="row" className={styles.ActionCell}>
                    <Button
                        className={`${styles.TableAddBU} ${allReceived ? styles.DisaBU : ""}`}
                        disabled={allReceived}
                        onClick={(e) => {
                            e.stopPropagation();
                            makeReceivedNew(remainingItemIds);
                        }}
                    >
                        {allReceived ? "All Received" : "Receive All"}
                    </Button>
                </TableCell>
            </StyledMainTableRow>

            <TableRow className={styles.ExpandRow}>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box sx={{ margin: 1 }} className={styles.ProductTableWrap}>
                            <Table size="small" aria-label="purchases">
                                <TableHead>
                                    <TableRow>
                                        <StyledMainTableCell>Item ID</StyledMainTableCell>
                                        <StyledMainTableCell align="left">Item</StyledMainTableCell>
                                        <StyledMainTableCell align="left"></StyledMainTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {item?.products.map((row) => (
                                        <TableRow key={row?.id}>
                                            <TableCell component="th" scope="row">
                                                {row?.item_id}
                                            </TableCell>
                                            <TableCell>{row?.product_title}</TableCell>
                                            <TableCell align="right">
                                                {row?.is_wh_received === 0 ? (
                                                    <Button
                                                        className={styles.CancelBU}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            makeReceivedNew([row?.id]);
                                                        }}
                                                    >
                                                        Receive
                                                    </Button>
                                                ) : (
                                                    <span className={styles.ReceivedLabel}>Received</span>
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
};

export default TableCustomRow;